import { render, staticRenderFns } from "./SelectVariant.vue?vue&type=template&id=2487e31c&scoped=true&"
import script from "./SelectVariant.vue?vue&type=script&lang=js&"
export * from "./SelectVariant.vue?vue&type=script&lang=js&"
import style0 from "./SelectVariant.vue?vue&type=style&index=0&id=2487e31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487e31c",
  null
  
)

export default component.exports